import 'react-native-gesture-handler'

import * as React from 'react'

import App from './components/App'

export default () => <App />
